import { Controller } from 'stimulus';

export default class extends Controller {
  static values = { listFrame: String, listUrl: String, previewUrl: String };

  sync({ detail: { name } }) {
    this.element.closest('dialog').setAttribute('aria-label', name);

    const frame = this.#listFrame;
    if (frame) {
      frame.src = this.listUrlValue;
      this.renamed = true;
    }
  }

  // The dialog returns focus to the Preview link that opened it, which the reload replaced.
  async restoreFocus({ target }) {
    if (!this.renamed || target !== this.element.closest('dialog')) {
      return;
    }

    const frame = this.#listFrame;
    await frame.loaded;
    if (!document.activeElement || document.activeElement === document.body) {
      frame.querySelector(`a[href="${this.previewUrlValue}"]`)?.focus();
    }
  }

  get #listFrame() {
    return document.getElementById(this.listFrameValue);
  }
}
